import { Component, EventEmitter, input, Output } from '@angular/core';
import { ChecklistAnswer } from '../../classes/checklist-answer';
import { AnswerType, ChecklistQuestion, QuestionType } from '../../classes/checklist-question';
import { Settings } from '../../settings.class';
import { LocalStorage } from '../../storage.class';

@Component({
    selector: 'app-checklist-question-pdf',
    standalone: false,
    templateUrl: './checklist-question-pdf.component.html',
    styleUrls: ['./checklist-question-pdf.component.scss'],
})
export class ChecklistQuestionPdfComponent {
    // Inputs using signal-based API
    question = input.required<ChecklistQuestion>();
    answer = input<ChecklistAnswer | null>(null);
    questionType = input<QuestionType>(QuestionType.YES_NO);
    interactive = input<boolean>(false);

    @Output() signOff = new EventEmitter<ChecklistAnswer>();

    // Expose enums and settings for template
    readonly QuestionType = QuestionType;
    readonly AnswerType = AnswerType;
    readonly Settings = Settings;

    canSignOff(): boolean {
        const answer = this.answer();
        return (
            this.interactive() &&
            !!answer &&
            !answer.signed_off_at &&
            !!answer.assigned_user &&
            answer.assigned_user.id === LocalStorage.getUser()?.id
        );
    }

    getAnswerLabel(value: string): string {
        switch (value) {
            case AnswerType.YES:
                return 'Ja';
            case AnswerType.NO:
                return 'Nee';
            case AnswerType.NA:
                return 'N.v.t';
            default:
                return value || '';
        }
    }
}
